import { defaultApiState } from "@/store/general.types";
import { ScreeningState } from "./screening.types";

export const screeningState: ScreeningState = {
    getScreeningRecordsCount: defaultApiState,
    getScreeningOverviewCount: defaultApiState,
    getStudyScreeningRecordsCount: defaultApiState,
    getAwaitingScreeningRecords: defaultApiState,
    editCitationRecord: defaultApiState,
    getStudiesByScreeningTypeStatus: defaultApiState,
    getMyDecisionScreeningRecords: defaultApiState,
    getConflictedStudyScreeningRecords: defaultApiState,
    getResolvedScreeningRecords: defaultApiState,
    revertResolved: defaultApiState,
    resolveConflict: defaultApiState,
    updateStudyScreeningStatus: defaultApiState,
    revertStudyScreeningDecision: defaultApiState,
    revertMyDecisionScreeningRecords: defaultApiState,
    mergeStudies: defaultApiState,
    unmergedStudies: defaultApiState,
    getHighlightedKeywords: defaultApiState,
    showAbstract: false,
    isKeywordHighlighted: false
}
